import { render, staticRenderFns } from "./FileUploadList.vue?vue&type=template&id=56b9ae00&"
import script from "./FileUploadList.vue?vue&type=script&lang=ts&"
export * from "./FileUploadList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports